import React, { useState } from 'react';

export default function AmazonImportModal({ orders, onConfirm, onCancel }) {
  const [selected, setSelected] = useState(orders.map(() => true));

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: '#0008', zIndex: 9999 }}>
      <div style={{ background: '#fff', margin: '5% auto', padding: 24, maxWidth: 600, borderRadius: 8 }}>
        <h3>Import Amazon Orders</h3>
        <p>Select which orders to import:</p>
        <ul>
          {orders.map((orderObj, idx) => {
            const order = orderObj.order || orderObj;
            const metadata = orderObj.metadata;
            console.log("Rendering orderObj in modal:", orderObj, "metadata:", metadata);
            return (
              <li key={idx} style={{ marginBottom: 12, borderBottom: '1px solid #eee' }}>
                <label>
                  <input
                    type="checkbox"
                    checked={selected[idx]}
                    onChange={e => {
                      const copy = [...selected];
                      copy[idx] = e.target.checked;
                      setSelected(copy);
                    }}
                  />
                  <b>{order.orderId || 'No ID'}</b> - {order.orderDate || ''} - {order.orderTotal || order.totalPrice || ''}
                </label>
                <div style={{ fontSize: '90%' }}>
                  {order.items && order.items.length ? order.items.map(i => i.title).join(', ') : ''}
                </div>
                {metadata && Object.keys(metadata).length > 0 && (
                  <div style={{ fontSize: '85%', color: '#555', marginTop: 4 }}>
                    <b>Custom Properties:</b>
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {Object.entries(metadata).map(([k, v]) => (
                        <li key={k}><b>{k}:</b> {v}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
        <button onClick={() => onConfirm(orders.filter((_, idx) => selected[idx]))} style={{ marginRight: 12 }}>Import Selected</button>
        <button onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
